import { RefundsApiAdapter, RefundsPage } from '../adapters/RefundsApiAdapter';
import { Filters } from '../models/Filters';

export class Service {
  constructor(private apiAdapter: RefundsApiAdapter) {}

  async getPaginated(filters: Filters = {}): Promise<RefundsPage> {
    if (filters.per_page && filters.per_page > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }
    return this.apiAdapter.getRefundsPaginated(filters);
  }
}
